// imports
import dayjs from 'dayjs';
import { Address } from 'abitype';
import utcPlugin from 'dayjs/plugin/utc';
import { signMessage } from 'wagmi/actions';
import { createAsyncThunk } from '@reduxjs/toolkit';

import { RootState } from '../..';
import { msgFromError } from '../../utils';
import { TEXTS } from '../../../../constants';
import { getToken } from '../../../../services/firebase';
import { user as USER_API, IUserPreferencesBody as USER_API_BODY } from '../../../api';

// interfaces / types / consts
dayjs.extend(utcPlugin);// enable UTC mode
type IUserPreferencesBody = Omit<USER_API_BODY, 'nonce' | 'signedMessage'> & { fetchToken?: boolean };

// exports
export const fetchPreferences = createAsyncThunk(
  'user/preferences/fetch',
  (wallet: Address, { rejectWithValue }) => USER_API.fetchPreferences(wallet)
    .catch((error) => rejectWithValue(msgFromError(error, TEXTS.ERROR_FETCH_PREFERENCES))),
  {
    condition: (_, { getState }) => {
      const { preferences } = (getState() as RootState).user;
      return preferences.fetchStatus !== 'loading';
    }
  }
);
export const resetPreferencesUpdateStatus = createAsyncThunk(
  'user/preferences/resetUpdateStatus',
  () => Promise.resolve(),
  {
    condition: (_, { getState }) => {
      const { preferences } = (getState() as RootState).user;
      return preferences.updateStatus !== 'loading';
    }
  }
);
export const updatePreferences = createAsyncThunk(
  'user/preferences/update',
  (body: IUserPreferencesBody, { dispatch, rejectWithValue }) => {
    const { fetchToken } = body;
    delete body.fetchToken;
    const promise = fetchToken ? getToken() : Promise.resolve('');

    return promise.then((fcmToken) => {
      const nonce = `${dayjs.utc().valueOf()}`;
      return signMessage({ message: nonce }).then((signedMessage) => {
        const apiBody: USER_API_BODY = { nonce, signedMessage, ...body };
        if (fetchToken) { apiBody.notifications!.fcmToken = fcmToken; }
        return USER_API.updatePreferences(apiBody);
      });
    })
      .then(() => {
        setTimeout(() => dispatch(resetPreferencesUpdateStatus()), 500);
        return Promise.resolve();
      })
      .catch((error) => rejectWithValue(msgFromError(error, TEXTS.ERROR_UPDATE_PREFERENCES)));
  },
  {
    condition: (_, { getState }) => {
      const { preferences } = (getState() as RootState).user;
      return preferences.updateStatus !== 'loading';
    }
  }
);

export default { fetchPreferences, updatePreferences, resetPreferencesUpdateStatus };
